import type { IconData } from '@stacksjs/iconify-core'

export const pacmanSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5c7.212 0 13.631 3.395 17.747 8.667c1.283 1.645.685 3.882-.911 4.898L26.794 24l14.042 8.936c1.596 1.015 2.194 3.252.91 4.897C37.632 43.105 31.213 46.5 24 46.5C11.574 46.5 1.5 36.426 1.5 24M23 13.5a2.5 2.5 0 1 0-5 0a2.5 2.5 0 0 0 5 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pacmanSolid
